<template>
  <div :class="{ noScroll: searchkeylist.length }" class="search searchModule">
    <div :class="{ searchkeylist: searchkeylist.length }">
      <header>
        <form action="/">
          <van-search
            :placeholder="defaultSearch ? '搜索“' + defaultSearch + '”' : ''"
            @cancel="cancel"
            @focus="input"
            @input="input"
            @search="search"
            clearable
            maxlength="32"
            show-action
            v-model="searchValue"
          ></van-search>
        </form>
        <!--      v-focus="isShow"-->
        <!--<span @click="cancel">取消</span>-->
      </header>
      <ul class="f12" v-if="searchkeylist.length">
        <li @click="searchkeyHandle(item)" class="over-ell-1" v-for="item of searchkeylist">
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="recordLabel">
      <div class="history" v-if="historyList && historyList.length > 0">
        <p>
          历史记录
          <img @click="deleteHistory" src="../../assets/images/delete.png" />
        </p>
        <ul>
          <li v-for="(item, index) in historyList" :key="index" @click="historyClick(item, 1)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="hot">
        <p>
          热门搜索
          <img src="../../assets/images/fire.png" />
        </p>
        <ul>
          <li v-for="(item, index) of hotList" :key="index" @click="hotClick(item, 2)">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="$store.state.skinTextSearchShow == 1">
      <skin-test :page="'search'"></skin-test>
    </div>
    <div
      v-if="guessList && guessList.length > 0"
      style="padding: 0.15rem 0.11rem 0; background: #fff; margin-top: 0.1rem"
    >
      <van-list
        v-model="recLoading"
        :finished="recFinished"
        :immediate-check="false"
        @load="onRecLoad"
      >
        <product-list
          :title="title"
          :productlist="guessList"
          :markPointData="{ scenepoint: 'SEARCH' }"
        ></product-list>
      </van-list>
    </div>
  </div>
</template>

<script>
import skinTest from '../common/skinTest'
import productList from '../common/productList'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'search',
  components: {
    skinTest,
    productList
  },
  data() {
    return {
      list: [],
      defaultSearch: '',
      hotList: [],
      historyList: [],
      title: '发现好物',
      guessList: [],
      recPage: 0,
      recLoading: false,
      recFinished: false,
      isShow: true,
      searchValue: '',
      searchType: 0,
      searchkeylist: []
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'search' })
    }
    this.getData()
    if (
      localStorage.getItem('historylist') !== null &&
      localStorage.getItem('historylist') !== undefined &&
      localStorage.getItem('historylist') !== ''
    ) {
      this.historyList = JSON.parse(localStorage.getItem('historylist'))
    }
    setTimeout(function () {
      window.scrollTo(0, 0)
    })
  },
  destroyed: function () {
    this.$dialog.close()
    this.$toast.clear()
  },
  methods: {
    getData: function () {
      this.defaultSearch = this.$store.state.defaultSearch ? this.$store.state.defaultSearch : ''
      var urlHot = this.$ajax.getHotItem_URL
      var that = this
      this.recPage = 0
      this.recFinished = false
      this.guessList = []
      this.onRecLoad()
      that.$customRequestAjax(urlHot).then(function (res) {
        console.log(res)
        if (res.data.code === 200) {
          that.hotList = res.data.list
        }
      })
    },
    onRecLoad: function () {
      if (this.recFinished) return
      var that = this
      that.recLoading = true
      that.recPage++
      var urlBuess =
        that.$ajax.getLoveItemInfo_URL +
        '?ischange=1&pageno=' +
        that.recPage +
        '&pagesize=' +
        that.pagesize
      that.$customRequestAjax(urlBuess).then(function (res) {
        that.recLoading = false
        if (res.data.code === 200) {
          var list = res.data.itemlist || []
          if (that.recPage === 1) {
            that.guessList = list
          } else {
            that.guessList = that.guessList.concat(list)
          }
          if (list.length < that.pagesize) {
            that.recFinished = true
          }
        } else {
          that.recFinished = true
        }
      })
    },
    searchkeyHandle: function (item) {
      this.searchValue = item
      this.search()
    },
    input: function () {
      this.$customRequestAjax(this.$ajax.getNameByKey_URL + '?keyword=' + this.searchValue).then(
        (res) => {
          if (res.data.code === 200) {
            this.searchkeylist = res.data.list
          }
        }
      )
    },
    cancel: function () {
      this.$router.go(-1)
    },
    search: function () {
      this.searchValue = this.searchValue || this.defaultSearch
      if (this.searchValue) {
        this.searchkeylist = []
        this.$router.push({
          path: '/searchlist',
          query: {
            searchval: encodeURIComponent(this.searchValue),
            searchType: this.searchType
          }
        })
      } else {
        this.$toast('请正确输入查询内容')
      }
    },
    deleteHistory: function () {
      localStorage.removeItem('historylist')
      this.historyList = []
    },
    historyClick: function (items, searchType) {
      this.searchValue = items
      this.searchType = searchType
      this.search()
    },
    hotClick: function (items, searchType) {
      if (items.url) {
        window.location.href = items.url
        return
      }
      this.searchValue = items.name
      this.searchType = searchType
      this.search()
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.children[0].children[0].children[1].children[0].children[0].focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
header {
  z-index: 2;
  padding: 0 0.11rem 0;
  padding-right: 0.03rem;
  background: #fff;
}
.recordLabel {
  margin-bottom: 0.11rem;
  background: #fff;
  padding: 0.14rem 0.11rem 0.07rem;
  .history ul,
  .hot ul {
    display: flex;
    display: -o-flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -moz-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
  }
  li {
    font-size: 0.12rem;
    color: #5e5e5e;
    padding: 0.06rem 0.15rem;
    background: #eeeff4;
    border-radius: 0.15rem;
    margin-top: 0.08rem;
    margin-right: 0.1rem;
    font-weight: 400;
  }
  .history {
    margin-bottom: 0.17rem;
    p {
      display: flex;
      display: -o-flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -o-justify-content: space-between;
      -ms-justify-content: space-between;
      -moz-justify-content: space-between;
      font-size: 0.12rem;
      color: #979797;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
  .hot {
    /*margin-top: 0.15rem;*/
    margin-bottom: 0.02rem;
    p {
      display: flex;
      display: -o-flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -moz-flex;
      font-size: 0.12rem;
      color: #979797;
    }
    img {
      width: 0.1rem;
      height: 0.12rem;
      margin-left: 0.1rem;
      margin-top: 0.03rem;
    }
  }
}
.list {
  background: #fff;
  ul {
    background: #fff;
    li {
      padding: 0.1rem 0.11rem 0;
      display: flex;
      display: -o-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      &:last-of-type {
        padding-bottom: 0.1rem;
      }
      > img {
        width: 1.22rem;
        height: 1.22rem;
      }
      .content {
        margin-left: 0.07rem;
        paddingf-top: 0.05rem;
        > p {
          font-size: 0.14rem;
          font-family: 'PingFangSC';
          font-weight: 400;
          color: rgba(41, 41, 41, 1);
          line-height: 0.2rem;
          height: 0.4rem;
          img {
            width: 0.19rem;
            height: 0.19rem;
            display: inline;
            position: relative;
            top: 0.04rem;
            left: 0.04rem;
          }
        }
        .evaluation {
          margin-top: 0.06rem;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          display: -webkit-flex;
          b {
            font-size: 0.11rem;
            color: #6c6c6c;
            font-weight: 400;
            &:last-of-type {
              margin-left: 0.25rem;
            }
          }
        }
        > span {
          display: flex;
          display: -webkit-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -moz-flex;
          align-items: center;
          -webkit-align-items: center;
          -o-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          margin-top: 0.27rem;
          i {
            display: block;
            font-size: 0.1rem;
            font-weight: 400;
            color: rgba(108, 108, 108, 1);
            line-height: 14px;
            font-style: normal;
            text-decoration: line-through;
          }
          b {
            display: block;
            color: #fc0324;
            font-size: 0.13rem;
            font-weight: 600;
            line-height: 0.2rem;
            margin-right: 0.05rem;
            &:before {
              content: '￥';
              color: #fc0324;
              font-size: 0.12rem;
              line-height: 17px;
            }
          }
        }
      }
    }
  }
}
.noScroll {
  height: 100%;
  overflow: hidden;
}
.searchkeylist {
  position: fixed;
  width: 100%;
  height: calc(100vh);
  z-index: 12;
  color: #333;
  background: #f5f5f5;
  ul {
    overflow-y: auto;
    height: calc(100vh - 0.6rem);
  }
  li {
    line-height: 0.3rem;
    background: #ffffff;
    position: relative;
    padding: 0 0.15rem;
    &:active {
      background: #eee;
    }
    &::after {
      content: '';
      display: block;
      height: 0.005rem;
      background: #ccc;
      position: absolute;
      left: 0.15rem;
      right: 0.15rem;
      bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/search.vue